import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input, Table } from 'reactstrap';
import { ButtonInsert, ButtonUpdate, ButtonDelete } from '../Buttons/Buttons';
import PersonalReclutamientoService from '../../axios_services/personalreclutamiento.service';

const ModalCandidatoReclutamiento = ({ isOpen, onClose, onModalClosed, registro }) => {
    const [candidatos, setCandidatos] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showForm, setShowForm] = useState(false);

    const emptyForm = { dni: '', nombre: '', apellido: '', estado_ingreso: '', fecha_ingreso: '' };
    const [form, setForm] = useState(emptyForm);
    const [editingId, setEditingId] = useState(null);

    const loadCandidatos = async () => {
        if (!registro) return;
        setLoadingList(true);
        try {
            const res = await PersonalReclutamientoService.getCandidatos(registro.reclutamiento_id);
            setCandidatos(res.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        if (isOpen && registro) {
            setForm(emptyForm);
            setEditingId(null);
            setShowForm(false);
            loadCandidatos();
        }
        // eslint-disable-next-line
    }, [isOpen, registro]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleNuevo = () => {
        setEditingId(null);
        setForm(emptyForm);
        setShowForm(true);
    };

    const handleEdit = (c) => {
        setEditingId(c.candidato_id);
        setForm({
            dni: c.dni || '',
            nombre: c.nombre || '',
            apellido: c.apellido || '',
            estado_ingreso: c.estado_ingreso !== null && c.estado_ingreso !== undefined
                ? String(c.estado_ingreso) : '',
            fecha_ingreso: c.fecha_ingreso ? c.fecha_ingreso.split('T')[0] : '',
        });
        setShowForm(true);
    };

    const handleCancelForm = () => {
        setShowForm(false);
        setEditingId(null);
        setForm(emptyForm);
    };

    const handleSubmit = async () => {
        if (!form.dni.trim() || form.dni.length !== 8) {
            alert('El DNI debe tener exactamente 8 dígitos.');
            return;
        }
        if (!form.nombre.trim() || !form.apellido.trim()) {
            alert('Nombre y Apellido son requeridos.');
            return;
        }
        setSaving(true);
        try {
            const payload = {
                reclutamiento_id: registro.reclutamiento_id,
                dni: form.dni.trim(),
                nombre: form.nombre.trim(),
                apellido: form.apellido.trim(),
                estado_ingreso: form.estado_ingreso !== '' ? parseInt(form.estado_ingreso) : null,
                fecha_ingreso: form.fecha_ingreso || null,
            };
            if (editingId) {
                await PersonalReclutamientoService.updateCandidato({ ...payload, candidato_id: editingId });
            } else {
                await PersonalReclutamientoService.insertCandidato(payload);
            }
            setShowForm(false);
            setEditingId(null);
            setForm(emptyForm);
            await loadCandidatos();
        } catch (err) {
            alert(err?.response?.data?.message || 'Error al guardar el candidato.');
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (candidato) => {
        if (!window.confirm(`¿Eliminar a ${candidato.nombre} ${candidato.apellido}?`)) return;
        setSaving(true);
        try {
            await PersonalReclutamientoService.deleteCandidato({ candidato_id: candidato.candidato_id });
            await loadCandidatos();
        } catch (err) {
            alert(err?.response?.data?.message || 'Error al eliminar.');
        } finally {
            setSaving(false);
        }
    };

    const estadoIngresoBadge = (val) => {
        if (val === null || val === undefined) return '-';
        return parseInt(val) === 1
            ? <span style={{ color: '#2e7d32', fontWeight: 700 }}>Ingreso</span>
            : <span style={{ color: '#b71c1c', fontWeight: 700 }}>No ingreso</span>;
    };

    if (!registro) return null;

    return (
        <Modal isOpen={isOpen} onClosed={onModalClosed} className="custom-modal" backdrop="static" size="xl">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>CANDIDATOS - SOLICITUD N°{registro.reclutamiento_id}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">

                    {/* Info solicitud */}
                    <div style={{
                        background: '#f8faff',
                        border: '1px solid #c3d8f5',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        marginBottom: '14px',
                        fontSize: '11px',
                        color: '#333',
                    }}>
                        <strong>Solicitud:</strong> {registro.solicitud}
                    </div>

                    {/* Boton agregar */}
                    <div className="nuevo-movimiento-section">
                        <ButtonInsert onClick={handleNuevo} />
                    </div>

                    {/* Formulario inline */}
                    {showForm && (
                        <div style={{
                            background: 'white',
                            border: '1px solid #dce3f0',
                            borderRadius: '10px',
                            padding: '14px 16px',
                            marginBottom: '14px',
                        }}>
                            <Form onSubmit={(e) => e.preventDefault()}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                                    <FormGroup style={{ marginBottom: 0 }}>
                                        <Label>DNI <span style={{ color: 'red' }}>*</span></Label>
                                        <Input
                                            className="form-control"
                                            type="text"
                                            name="dni"
                                            value={form.dni}
                                            onChange={handleChange}
                                            placeholder="8 digitos"
                                            maxLength={8}
                                        />
                                    </FormGroup>
                                    <FormGroup style={{ marginBottom: 0 }}>
                                        <Label>Nombre <span style={{ color: 'red' }}>*</span></Label>
                                        <Input
                                            className="form-control"
                                            type="text"
                                            name="nombre"
                                            value={form.nombre}
                                            onChange={handleChange}
                                            placeholder="Nombre(s)"
                                        />
                                    </FormGroup>
                                    <FormGroup style={{ marginBottom: 0 }}>
                                        <Label>Apellido <span style={{ color: 'red' }}>*</span></Label>
                                        <Input
                                            className="form-control"
                                            type="text"
                                            name="apellido"
                                            value={form.apellido}
                                            onChange={handleChange}
                                            placeholder="Apellido(s)"
                                        />
                                    </FormGroup>
                                    <FormGroup style={{ marginBottom: 0 }}>
                                        <Label>Estado de Ingreso</Label>
                                        <Input
                                            className="form-control"
                                            type="select"
                                            name="estado_ingreso"
                                            value={form.estado_ingreso}
                                            onChange={handleChange}
                                            style={{ maxHeight: 'unset', borderRadius: '6px' }}
                                        >
                                            <option value="">-- Seleccionar --</option>
                                            <option value="0">No ingreso</option>
                                            <option value="1">Ingreso</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup style={{ marginBottom: 0 }}>
                                        <Label>Fecha de Ingreso</Label>
                                        <Input
                                            className="form-control"
                                            type="date"
                                            name="fecha_ingreso"
                                            value={form.fecha_ingreso}
                                            onChange={handleChange}
                                        />
                                    </FormGroup>
                                </div>

                                <div className="button-container" style={{ marginTop: '12px' }}>
                                    <Button
                                        className="button-custom"
                                        disabled={saving}
                                        onClick={() => {
                                            if (window.confirm('Confirmar los datos del candidato?')) {
                                                handleSubmit();
                                            }
                                        }}
                                    >
                                        {saving ? 'GUARDANDO...' : editingId ? 'ACTUALIZAR' : 'REGISTRAR'}
                                    </Button>
                                    <Button
                                        style={{
                                            background: '#6b7280',
                                            border: 'none',
                                            borderRadius: '8px',
                                            color: 'white',
                                            fontSize: '12px',
                                            padding: '8px 16px',
                                        }}
                                        onClick={handleCancelForm}
                                    >
                                        CANCELAR
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    )}

                    {/* Tabla de candidatos */}
                    {loadingList ? (
                        <p style={{ textAlign: 'center', fontSize: '11px', color: '#888' }}>Cargando...</p>
                    ) : (
                        <div className="table-container">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>DNI</th>
                                        <th>Nombre</th>
                                        <th>Apellido</th>
                                        <th>Estado Ingreso</th>
                                        <th>Fecha Ingreso</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {candidatos.length > 0 ? candidatos.map((c, i) => (
                                        <tr key={c.candidato_id}
                                            style={editingId === c.candidato_id ? { background: '#fff8e1' } : {}}>
                                            <td>{i + 1}</td>
                                            <td>{c.dni || '-'}</td>
                                            <td>{c.nombre || '-'}</td>
                                            <td>{c.apellido || '-'}</td>
                                            <td>{estadoIngresoBadge(c.estado_ingreso)}</td>
                                            <td>{c.fecha_ingreso ? c.fecha_ingreso.split('T')[0] : '-'}</td>
                                            <td>
                                                <div className="acciones-container">
                                                    <ButtonUpdate onClick={() => handleEdit(c)} />
                                                    <ButtonDelete onClick={() => handleDelete(c)} />
                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={7} className="sin-data">
                                                No hay candidatos registrados para esta solicitud.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    )}

                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalCandidatoReclutamiento;
